/* @flow */
import { Map, List, Record } from 'immutable';

export const TAGS_ENDPOINT = '/services/tags';
export const INDICATOR_TAGS_ENDPOINT = `/services/indicator-tags`;

export type RawTag = {
  id: number | null,
  guid: string,
  count: number,
  name: string,
  enclaveId?: string,
  color?: string,
};

export const Attribute = Record({
  id: null,
  guid: '',
  count: -1,
  name: '',
});

export const EnclaveTag = Record({
  id: null,
  guid: '',
  count: -1,
  name: '',
  enclaveId: '',
});

/* Custom enclave-specific tags for indicators */
export const IndicatorTag = Record({
  guid: '',
  name: '',
  enclaveId: '',
});

/* Type for Indicator Tags store object */
export type IndicatorTags = Map<string, List<IndicatorTag>>;



// WEBPACK FOOTER //
// ./src/app/modules/tags/types.js